"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalizeFirstLetter = capitalizeFirstLetter;
exports.titleCase = titleCase;
exports.formatPrice = formatPrice;
exports.getTitleRule = getTitleRule;
exports.getTitleRows = getTitleRows;
exports.createArticleTitleRowsForWeb = exports.createTitleObject = exports.shapeDataBasedOnMobileProduct = exports.truncate = exports.formatDescription = exports.appWithNRooms = void 0;

var _slugify = require("./slugify");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PROPERTY_DESCRIPTION_REGEXP_REPLACE = /<br \/>|<br\/>|\r|\n/g;
var appWithNRooms = {
  1: 'Monolocale',
  2: 'Bilocale',
  3: 'Trilocale',
  4: 'Quadrilocale'
};
exports.appWithNRooms = appWithNRooms;

var adjustDescriptionLength = function adjustDescriptionLength(content, limit) {
  var adjustedLengthContent = content;

  if (adjustedLengthContent.join(' ').length > 500) {
    adjustedLengthContent = adjustedLengthContent.slice(0, limit - 5);

    if (adjustedLengthContent.join(' ').length > 500) {
      adjustedLengthContent = adjustDescriptionLength(adjustedLengthContent, limit - 5);
    }
  }

  return adjustedLengthContent;
};

var formatDescription = function formatDescription(originalDescription) {
  var description = originalDescription.split(PROPERTY_DESCRIPTION_REGEXP_REPLACE).join(' ');
  return truncate(description, 60);
}; // Truncate a string at the last word boundary


exports.formatDescription = formatDescription;

var truncate = function truncate(string, limit) {
  if (!string || !limit) {
    return;
  }

  var content = string.trim();
  content = content.split(' ').slice(0, limit);
  content = adjustDescriptionLength(content, limit).join(' ');
  var dots = string.length > content.length ? '...' : '';
  return "".concat(content).concat(dots);
};

exports.truncate = truncate;

var shapeDataBasedOnMobileProduct = function shapeDataBasedOnMobileProduct() {
  var inpData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var geoData = inpData.geoData;

  try {
    var address = {
      show: geoData.show_address && geoData.has_street,
      locality: geoData.city || '',
      province: geoData.province || '',
      streetAddress: geoData.street || '',
      district: geoData.district_name || '',
      block: geoData.block_name || '',
      provinceFullName: geoData.province_full_name || ''
    };

    var product = _objectSpread({}, inpData, {
      address: address,
      features: {
        rooms: inpData.numRooms
      }
    });

    delete product.geoData;
    delete product.numRooms;
    return product;
  } catch (error) {
    return {};
  }
};

exports.shapeDataBasedOnMobileProduct = shapeDataBasedOnMobileProduct;

var createTitleObject = function createTitleObject(_ref) {
  var _ref$product = _ref.product,
      product = _ref$product === void 0 ? {} : _ref$product,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? [] : _ref$title;
  var titleObj = {};
  var titleWithProject = title.filter(function (i) {
    return !!i;
  });

  switch (titleWithProject.length) {
    case 1:
      titleObj.firstRow = titleWithProject[0];
      break;

    case 2:
      titleObj.firstRow = titleWithProject[0];
      titleObj.secondRow = titleWithProject[1];
      break;

    case 3:
      titleObj.firstRow = titleWithProject[0];
      titleObj.secondRow = titleWithProject[1];
      titleObj.thirdRow = titleWithProject[2];
      break;

    default:
      console.log('Error creating title srp card');
      break;
  }

  return titleObj;
};
/**
 * SHARED FUNCTIONS WITH APP
 */


exports.createTitleObject = createTitleObject;
var titleRules = {
  "regionLocation": {
    title: "streetAddress",
    subtitle: "blockOrZone, locality",
    withPropertyType: true
  },
  "singleLocation": {
    title: "streetAddress",
    subtitle: "blockOrZone",
    withPropertyType: true
  },
  "multipleLocations": {
    title: "streetAddress",
    subtitle: "blockOrZone, locality",
    withPropertyType: true
  },
  "singleZone": {
    title: "streetAddress",
    subtitle: "block",
    withPropertyType: true
  },
  "singleBlock": {
    title: "streetAddress",
    subtitle: "",
    withPropertyType: true
  }
};
var CAPITALIZATION_EXCEPTIONS = {
  'a': 'a',
  'al': 'al',
  'all': 'all',
  'allo': 'allo',
  'alla': 'alla',
  'agli': 'agli',
  'alle': 'alle',
  'd': 'd',
  'da': 'da',
  'de': 'de',
  'di': 'di',
  'del': 'del',
  'dell': 'dell',
  'della': 'della',
  'dello': 'dello',
  'dei': 'dei',
  'degli': 'degli',
  'delle': 'delle',
  'in': 'in',
  // 'delli': 'delli', // disabled, as it exists capitalized as a name
  'i': 'I',
  'ii': 'II',
  'iii': 'III',
  'iv': 'IV',
  'v': 'V',
  'vi': 'VI',
  'vii': 'VII',
  'viii': 'VIII',
  'ix': 'IX',
  'x': 'X',
  'xi': 'XI',
  'xii': 'XII',
  'xiii': 'XIII',
  'xiv': 'XIV',
  'xv': 'XV',
  'xvi': 'XVI',
  'xvii': 'XVII',
  'xviii': 'XVIII',
  'xix': 'XIX',
  'xx': 'XX',
  'xxi': 'XXI',
  'xxii': 'XXII',
  'xxiii': 'XXIII',
  'xxiv': 'XXIV',
  'xxv': 'XXV',
  'xxvi': 'XXVI',
  'xxvii': 'XXVII',
  'xxviii': 'XXVIII',
  'xxix': 'XXIX',
  'xxx': 'XXX',
  'xxxi': 'XXXI'
};
var DEFAULT_TITLE_RULE = getTitleRule();

function capitalizeFirstLetter(string) {
  if (typeof string === 'string' && string.length > 0) return string[0].toUpperCase() + string.slice(1);
  return string;
}

function titleCase(str) {
  var splitStr = str.toLowerCase().split(' ');

  for (var i = 0; i < splitStr.length; i++) {
    var word = splitStr[i];
    splitStr[i] = CAPITALIZATION_EXCEPTIONS[word] || word.charAt(0).toUpperCase() + word.substring(1);
    word = splitStr[i];
    var index = word.indexOf('\'');

    if (index >= 0) {
      // remove capitalization of preposition, if needed, and capitalize the following word
      var prefix = word.substr(0, index);
      splitStr[i] = (CAPITALIZATION_EXCEPTIONS[prefix.toLowerCase()] || prefix) + '\'' + word.charAt(index + 1).toUpperCase() + word.substring(index + 2);
    }
  }

  return splitStr.join(' ');
}

function formatPrice(string) {
  var num = parseInt(string, 10),
      suffix = '';

  if (!isNaN(num)) {
    if (num >= 1000000) {
      // && (num % 1000000 == 0)   show decimals
      num = num / 1000000;
      suffix = 'M';
    } else if (num > 1000 && num % 1000 == 0) {
      num = num / 1000;
      suffix = 'mila';
    }
  } else {
    num = string;
  }

  return [num, suffix];
}

function getProductType(product) {
  var type = product.typeLabel;

  if (type === 'Appartamento') {
    var numRooms = product.features.rooms;

    if (numRooms === 1) {
      return 'Monolocale';
    } else if (numRooms === 2) {
      return 'Bilocale';
    } else if (numRooms === 3) {
      return 'Trilocale';
    } else if (numRooms === 4) {
      return 'Quadrilocale';
    }
  }

  return type;
}
/**
 * Get title rule object based on the inputs
 * @param  {Object} [searchApiQuery={}]  DS Api query request object
 * @param  {Object} [searchApiResult={}] DS Api response
 * @return {Object}                      contains the title, subtitle and property type title flag rules
 */


function getTitleRule() {
  var searchApiQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var searchApiResult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var titleRule = null;
  var locationCount = 0; // let zoneCount = searchApiQuery.filters?.zones?.length || 0; // v1 version

  var zoneCount = 0;
  var blockCount = 0;
  var lastLocationType = ''; // check matched locations to identify title rules

  if (Array.isArray(searchApiResult.data && searchApiResult.data.resolved_locations)) {
    var resolved_locations = searchApiResult.data.resolved_locations;
    resolved_locations.map(function (item) {
      if (item.type === 'zone') {
        locationCount = 1; // zones can now be only of 1 city

        zoneCount++;
        lastLocationType = 'zone';
      } else if (item.type === 'block') {
        locationCount = 1; // blocks can be only of 1 city

        blockCount++;
        lastLocationType = 'block';
      } else {
        locationCount++;
        lastLocationType = item.type;
      }
    });
  }

  switch (locationCount) {
    case 0:
      titleRule = titleRules['regionLocation'];
      break;

    case 1:
      titleRule = blockCount === 1 && zoneCount === 0 ? titleRules['singleBlock'] : zoneCount === 1 && blockCount === 0 ? titleRules['singleZone'] : lastLocationType === 'state' || lastLocationType === 'region' || lastLocationType === 'province' || lastLocationType === 'nonadminzone' || lastLocationType === 'nonadminsubzone' || lastLocationType === 'street' ? titleRules['regionLocation'] : titleRules['singleLocation'];
      break;

    default:
      // > 1
      titleRule = titleRules['multipleLocations'];
  } // Hiding property types does not make sense anymore, with further modification e.g."trilocale" added later
  // // do not show property type when a single tipology is specified as filter 
  // // const propertyTypes = searchApiQuery.filters?.propertyTypes;  // v1 version
  // const propertyTypes = searchApiQuery.propertyTypes;
  // const withPropertyType = !(Array.isArray(propertyTypes) && propertyTypes.length === 1);
  // titleRule.withPropertyType = withPropertyType; // always show


  return titleRule;
}
/**
 * Get the three rows representation of the title based on the rules
 * @param  {Product} product  Product instance
 * @param  {Object} titleRule title, subtitle and property type title flag rules
 * @return {Object}           first, second and third rows of title
 */


function getTitleRows(product) {
  var titleRule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_TITLE_RULE;
  var titleRows = [];

  try {
    var _product$address = product.address,
        canShowAddress = _product$address.show,
        _product$address$loca = _product$address.locality,
        locality = _product$address$loca === void 0 ? '' : _product$address$loca,
        _product$address$prov = _product$address.province,
        province = _product$address$prov === void 0 ? '' : _product$address$prov,
        _product$address$stre = _product$address.streetAddress,
        streetAddress = _product$address$stre === void 0 ? '' : _product$address$stre,
        _product$address$dist = _product$address.district,
        district = _product$address$dist === void 0 ? '' : _product$address$dist,
        _product$address$bloc = _product$address.block,
        block = _product$address$bloc === void 0 ? '' : _product$address$bloc,
        _product$address$prov2 = _product$address.provinceFullName,
        provinceFullName = _product$address$prov2 === void 0 ? '' : _product$address$prov2;
    var address = canShowAddress && streetAddress && streetAddress.length ? titleCase(streetAddress) : ''; // const propertyType = !product.isProjectProfile && (titleRule.withPropertyType || !address) ? getProductType(product) : '';

    var propertyType = !product.isProjectProfile ? titleRule.withPropertyType || !address ? getProductType(product) : '' : "Nuova costruzione".concat(product.residenceName ? " \"".concat(product.residenceName, "\"") : '');
    var blockOrZone = block || district || '';
    var firstRow = propertyType + (propertyType && address ? ' in ' : '') + address;
    var secondRow = titleRule.subtitle === 'block' ? block : titleRule.subtitle.includes('blockOrZone') ? blockOrZone : '';

    if (titleRule.subtitle.includes('locality')) {
      // streetAddress, locality
      if (secondRow) {
        secondRow += ' • ';
      }

      secondRow += !isNaN(province) || provinceFullName === locality ? // exclude France and capoluoghi di provincia
      "".concat(locality) : "".concat(locality, " (").concat(province, ")");
    }

    titleRows = [firstRow, secondRow];
  } catch (err) {
    console.log("ERROR: getTitleRows: ".concat(err)); // eslint-disable-line no-console
  }

  return titleRows;
}
/**
 * ****** SHARED FUNCTION *******
 * ****** END *******
 */


var createArticleTitleRowsForWeb = function createArticleTitleRowsForWeb(_ref2) {
  var titleFilters = _ref2.titleFilters,
      resolved_locations = _ref2.resolved_locations;
  var articleTitleRule = getTitleRule({}, {
    data: {
      resolved_locations: resolved_locations
    }
  });
  var product = shapeDataBasedOnMobileProduct(titleFilters);
  var title = getTitleRows(product, articleTitleRule);
  var groupTitle = createTitleObject({
    title: title,
    product: product
  });
  return groupTitle;
};

exports.createArticleTitleRowsForWeb = createArticleTitleRowsForWeb;